import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { CommonModule } from '@angular/common';
import { CustomAvatarComponent } from "../../../../shared/components/custom-avatar/custom-avatar.component";
import { InviteNewMemberDialogComponent } from "../../components/dialogs/invite-new-member-dialog/invite-new-member-dialog.component";
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { CompanyService } from '../../../../core/api/company.service';
import { UserDataService } from '../../../../core/services/user-data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { CompanyMember } from '../../../../core/interfaces/company-interfaces';
import { UserInitialsService } from '../../../../core/services/user-initials.service';
import { combineLatest, firstValueFrom } from 'rxjs';
import { DeleteTeamMemberDialogComponent } from "../../components/dialogs/delete-team-member-dialog/delete-team-member-dialog.component";
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";

@Component({
  selector: 'app-settings-team-page',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, MobileTopbarComponent, TabButtonComponent, CustomButtonComponent, CommonModule, CustomAvatarComponent, InviteNewMemberDialogComponent, TranslocoPipe, ToastComponent, DeleteTeamMemberDialogComponent, CustomFooterComponent],
  templateUrl: './settings-team-page.component.html',
  styleUrl: './settings-team-page.component.css'
})
export class SettingsTeamPageComponent {
  selectedSidebarItemId: number = 13;

  // List of team members
  listOfTeamMembers: CompanyMember[] = [];

  rolesOptions: string[] = [];

  // Invite new member dialog
  @ViewChild(InviteNewMemberDialogComponent) inviteNewMemberDialog!: InviteNewMemberDialogComponent;

  // Delete team member confirmation dialog
  @ViewChild(DeleteTeamMemberDialogComponent) deleteTeamMemberConfirmation!: DeleteTeamMemberDialogComponent;

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // User email
  get userEmail(): string {
    return this.userData.getUser()?.email!;
  };

  constructor(private cdRef: ChangeDetectorRef, private companyService: CompanyService, private userData: UserDataService, private apiError: ApiErrorService, private userInitialsService: UserInitialsService, private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.cdRef.detectChanges();

    const roleKeys = [
      'shared.roles.admin',
      'shared.roles.manager',
      'shared.roles.sr_manager',
      'shared.roles.director'
    ];

    combineLatest(roleKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.rolesOptions = translations;
    });

    // Fetching team members
    this.loadMembers();
  }

  openInviteNewMemberDialog = () => {
    this.inviteNewMemberDialog.openModal();
  }

  loadMembers() {
    this.companyService.getMembers(this.userData.getUser()!.company!.id
    ).subscribe({
      next: (response) => {
        if (response) {
          this.listOfTeamMembers = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      }
    });
  }

  getUserInitials(firstName: string, lastName: string): string {
    return this.userInitialsService.getUserInitials(firstName, lastName);
  }

  getTranslatedRole(serverRoleString: string) {
    const serverRoleOptions = ["ADMIN", "MANAGER", "SR_MANAGER", "DIRECTOR"];
    const selectedRole = serverRoleOptions.indexOf(serverRoleString);

    return this.rolesOptions[selectedRole];
  }

  async deleteTeamMember(teamMemberInfo: CompanyMember) {
    var confirmation = await this.deleteTeamMemberConfirmation.openModal();

    if (!confirmation) {
      return;
    }

    if (teamMemberInfo.email === this.userEmail) {
      return;
    }

    try {
      await firstValueFrom(this.companyService.removeUserFromCompany(teamMemberInfo.id, this.userData.getUser()?.company?.id!));

      this.loadMembers();

      this.toast.showToast('shared.success', 'settings.successful_delete', 'success', 4000, true);
    }
    catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }
}
